import React, {useState, useEffect, useReducer} from 'react';
import FileUploader from '../../../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/FileUploader/FileUploader';
import FileUploaded from '../../../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/FileUploaded/FileUploaded';
import FileLoader from '../../../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/FileUploader/FileUploader';
import UploadedFiles from '../../../../../../../onboarding/src/stories/components/OnboardingNew/GccComponents/UploadedFiles/UploadedFiles';
import RadioBtn from '../../Radiobtn/Radiobtn';
import * as S from './AisUpdateDetailsForm.styles';

const initialFileUploadState = {
  fileUplaoded: false,
  isLoading: false,
  approve: false,
  imageSizeExceededError: '',
  filePath: '',
  fileType: '',
  fileData: null,
  fileName: '',
};

function stateFileReducer(state, action) {
  switch (action.type) {
    case 'FILE_UPLAODED':
      return {...state, fileType: action.payload};
    case 'FILE_UPLAODED_PATH':
      return {
        ...state,
        fileUplaoded: true,
        isLoading: false,
        filePath: action.payload.filePath,
        fileName: action.payload.fileName,
        fileData: action.payload.fileData,
      };
    case 'FILE_APPROVED_WITHOUT_API_CALL':
      return {
        ...state,
        approve: true,
      };
    case 'REJECT_FILE_APPROVE':
      return {
        ...initialFileUploadState,
      };
    default:
      return state;
  }
}

const AisFormFields = ({
  fieldType,
  register,
  formRowType,
  name,
  placeholder,
  label,
  value,
  onChange,
  onFileApprove,
  isRequired,
  options,
  dataSource,
  isDisabled,
}) => {
  const [stateFile, dispatchFileState] = useReducer(stateFileReducer, initialFileUploadState);
  const [fileType, setFileType] = useState('');

  useEffect(() => {
    if (fieldType === 'DOCUMENT_UPLOAD_WITH_APPROVE' && value) {
      dispatchFileState({type: 'FILE_UPLAODED', payload: value?.type});
      dispatchFileState({
        type: 'FILE_UPLAODED_PATH',
        payload: {filePath: value, fileName: value?.name, fileData: value},
      });
      dispatchFileState({type: 'FILE_APPROVED_WITHOUT_API_CALL'});
    }
  }, [value, fieldType]);

  const getFileInfo = info => {
    dispatchFileState({type: 'FILE_UPLAODED', payload: info[0].type});
    setFileType(info[0].type);
  };

  const selectFile = (val, fileData) => {
    dispatchFileState({
      type: 'FILE_UPLAODED_PATH',
      payload: {filePath: val, fileName: fileData?.name, fileData: fileData},
    });
  };

  const onApprove = data => {
    onFileApprove !== undefined
      ? onFileApprove(stateFile?.filePath, name)
      : dispatchFileState({type: 'FILE_APPROVED_WITHOUT_API_CALL'});

    const e = {target: {value: stateFile?.fileData}};

    onChange && onChange(e);
  };

  const onRejectFileApprove = () => {
    dispatchFileState({type: 'REJECT_FILE_APPROVE'});
    const e = {target: {value: ''}};
    onChange && onChange(e);
  };

  return fieldType === 'SEARCH_DROPDOWN' ? (
    <>
      {formRowType === 'VERTICAL_ALIGN_WITH_LABEL' ? (
        <S.TitleWrapper>
          <S.LabelHorizontal>{label}</S.LabelHorizontal>
          <S.CommonSelect
            value={value}
            onChange={onChange}
            //disabled={disableInput}
          >
            <option value={''}>{value ? value : placeholder}</option>
            {dataSource?.length > 0 &&
              dataSource.map((item, idx) => {
                return <option value={item}>{item}</option>;
              })}
          </S.CommonSelect>
        </S.TitleWrapper>
      ) : (
        <>
          <S.TitleWrapper>
            <S.LabelHorizontal>{label}</S.LabelHorizontal>
            <S.CommonSelect value={value} onChange={onChange} disabled={isDisabled}>
              <option value={''}>{value ? value : placeholder}</option>
              {dataSource?.length > 0 &&
                dataSource.map((item, idx) => {
                  return <option value={item}>{item}</option>;
                })}
            </S.CommonSelect>
          </S.TitleWrapper>
        </>
      )}
    </>
  ) : fieldType === 'TEXT_INPUT' ? (
    <S.InputHorizontalWrapper isLabel={label}>
      {label && (
        <S.InputLabelHorizontal>
          {label} {isRequired && <span>*</span>}
        </S.InputLabelHorizontal>
      )}
      <S.InputBox
        disabled={isDisabled}
        value={value}
        {...register}
        onChange={onChange}
        placeholder={placeholder}
      />
    </S.InputHorizontalWrapper>
  ) : fieldType === 'DOCUMENT_UPLOAD_WITH_APPROVE' ? (
    <>
      {stateFile?.fileType === '' && !stateFile?.approve ? (
        <S.FileUploadderHorizontalWrapper>
          {label && (
            <S.InputLabelHorizontal>
              {label} {isRequired && <span>*</span>}
            </S.InputLabelHorizontal>
          )}
          <FileLoader
            fileTypes={['.png, .jpeg, .pdf']}
            onFileSelect={selectFile}
            getFileInfo={getFileInfo}
            {...register}
          >
            <p className="font10">
              Upload <span className="latoBold">Cancelled Cheque</span>
            </p>
            <p className="font10">PDF, JPEG Only | Below 5MB</p>
          </FileLoader>
        </S.FileUploadderHorizontalWrapper>
      ) : stateFile?.approve ? (
        <>
          <S.InputLabelHorizontal>
            {label} {isRequired && <span>*</span>}
          </S.InputLabelHorizontal>
          <FileUploaded
            closeIcon={true}
            title={stateFile?.fileName}
            //fileSize="851KB"
            onClose={onRejectFileApprove}
          />
        </>
      ) : (
        <S.FileUploadderHorizontalWrapper>
          <UploadedFiles
            fileType={stateFile?.fileType}
            filePath={stateFile?.filePath}
            fileTypes={['.png, .jpeg, .pdf']}
            onFileSelect={selectFile}
            getFileInfo={getFileInfo}
            onApprove={onApprove}
            //disableSubmitButton={disableSubmitButton}
          />
        </S.FileUploadderHorizontalWrapper>
      )}
    </>
  ) : fieldType === 'RADIO_GROUP' ? (
    <>
      {label && <span className="aisListHeading latoBlack">{label}</span>}
      {options?.length &&
        options.map((item, index) => {
          return (
            <RadioBtn
              key={index}
              id={'radioID'}
              variant="DOT"
              inputName={label}
              //onChange={onChange}
              //isChecked={false}
              radioClicker={onChange}
              customClass="listingRadio appendRight24"
              element={item}
            />
          );
        })}
    </>
  ) : (
    <></>
  );
};

export default AisFormFields;
